import {configureStore} from '@reduxjs/toolkit'
import medicationWidgetReducer from '../ducks/medication-widget/slice';

export const store = configureStore({
    reducer: {
        medicationWidgetState: medicationWidgetReducer
    },
})

export type RootState = ReturnType<typeof store.getState>